<div class="conteneur" *ngIf="!loading; else loader">
  <div class="fx-direction-row fx-wrap">

    <mat-card appearance="raised" class="card fx-flex-grow" *ngIf="permToDisplayDisponibilites">
      <mat-card-header class="card-header fx-direction-row fx-between-start">
        <mat-card-title class="fx-direction-row fx-start-center">
          <app-icon style="margin-right: 5px;" type="do" icon="jour-ferie">
          </app-icon>
          <span>Disponibilités</span>
        </mat-card-title>
        @if(permToEdit){
        <button mat-mini-fab color="primary" matTooltip="Modifier" routerLink="/account/assmat/availability">
          <mat-icon>edit</mat-icon>
        </button>
        }
      </mat-card-header>
      <mat-card-content style="flex: 1; margin-left: 20px;">
        <mat-list>
          @for (item of availability; track item; let last = $last) {
          <mat-list-item style="height: auto;">
            @if (item.active) {
            <mat-icon matListItemIcon class="primary">event_available</mat-icon>
            }@else {
            <mat-icon matListItemIcon class="warn">event_busy</mat-icon>
            }
            <div>
              <b>Dates : </b>
              {{item.dateDebut && !item.dateFin ? 'À partir du' : !item.dateDebut && item.dateFin ? "Jusqu'au" :
              !item.dateDebut && !item.dateFin ? "" : 'Du'}}
              {{item.dateDebut | date:"shortDate"}} {{item.dateFin && item.dateDebut ? 'au' : ''}}
              {{item.dateFin | date:"shortDate"}}
            </div>
            <div>
              <b>Capacité : </b>
              {{item.capacite}}
            </div>
            @if (configMentalo.displayAgrementSecondaire) {
            <div>
              <b>Agrément secondaire : </b>
              {{item.agrementSecondaire.designation ? item.agrementSecondaire.designation : "Aucun"}}
            </div>
            }
          </mat-list-item>
          @if (!last) {
          <mat-divider style="margin-block: 10px;"></mat-divider>
          }
          }
        </mat-list>
      </mat-card-content>
    </mat-card>

    @if(permToDisplayFormations){
    <mat-card appearance="raised" class="card fx-flex-grow">
      <mat-card-header class="card-header fx-direction-row fx-between-start">
        <mat-card-title class="fx-direction-row fx-start-center">
          <app-icon style="margin-right: 5px;" type="do" icon="formation">
          </app-icon>
          <span>Formations</span>
        </mat-card-title>
        @if(permToEdit){
        <button mat-mini-fab color="primary" matTooltip="Modifier" routerLink="/account/assmat/formation">
          <mat-icon>edit</mat-icon>
        </button>
        }
      </mat-card-header>
      <mat-card-content style="flex: 1; margin-left: 20px;">
        <mat-list>
          @for (formation of formations; track formation; let last = $last) {
          <mat-list-item style="height: auto;">
            <div>
              <b>Programme : </b>
              {{formation.programme}}
            </div>
            <div>
              <b>Dates : </b>
              {{formation.dateDebut && !formation.dateFin ? 'À partir du' : !formation.dateDebut && formation.dateFin ?
              "Jusqu'au" :
              !formation.dateDebut && !formation.dateFin ? "" : 'Du'}}
              {{formation.dateDebut | date:"shortDate"}} {{formation.dateFin && formation.dateDebut ? 'au' : ''}}
              {{formation.dateFin | date:"shortDate"}}
            </div>
            @if(formation.lieu){
            <div>
              <b>Lieu : </b>
              {{formation.lieu}}
            </div>
            }
          </mat-list-item>
          @if (!last) {
          <mat-divider style="margin-block: 10px;"></mat-divider>
          }
          }
        </mat-list>
      </mat-card-content>
    </mat-card>
    }

    @for (step of assmatFormSteps; track $index) {
    <mat-card appearance="raised" class="card"
      [ngClass]="{'multiple-card': assmatFormSteps.length > 1, 'one-card': assmatFormSteps.length <= 1 }">
      <mat-card-header class="card-header fx-direction-row fx-between-start">
        <mat-card-title class="fx-direction-row fx-start-center">
          @if (step.stepName === 'souhaitsAccueil') {
          <app-icon style="margin-right: 5px;" type="do" icon="accueil" />
          }
          @if (step.stepName === 'valeursLibres') {
          <mat-icon style="margin-right: 5px;">description</mat-icon>
          }
          @if (step.stepName === 'mam') {
          <app-icon style="margin-right: 5px;" type="do" icon="mam" />
          }

          @if (step.stepName === 'coordinates') {
          <app-icon style="margin-right: 5px;" type="do" icon="courrier" />
          }
          <span>{{ step.label }}</span>
        </mat-card-title>
        <button mat-mini-fab color="primary" [matTooltip]="permToEdit ? 'Modifier' : 'Voir'"
          routerLink="/account/assmat/{{step.stepName}}">
          @if (permToEdit) {
          <mat-icon>edit</mat-icon>
          }@else {
          <mat-icon>visibility</mat-icon>
          }
        </button>
      </mat-card-header>
      <mat-card-content style="flex: 1; margin-left: 20px;">
        @if(step.stepName === 'coordinates'){
        <ng-container [ngTemplateOutlet]="coordinates"></ng-container>
        }
        @if (step.stepName === 'souhaitsAccueil') {
        <ng-container [ngTemplateOutlet]="souhaitsAccueil"></ng-container>
        }
        @if (step.stepName === 'mam') {
        <ng-container [ngTemplateOutlet]="mam"></ng-container>
        }
        @if (step.stepName === 'valeursLibres') {
        <ng-container [ngTemplateOutlet]="valeursLibres"></ng-container>
        }
      </mat-card-content>
    </mat-card>
    }
  </div>
</div>

<ng-template #mam>
  @if (selectedMAM) {
  <p style="font-weight: 500;">{{selectedMAM.designation}}</p>
  <p style="margin-top: 2px;">
    <span>{{ selectedMAM.numRue }} {{ selectedMAM.rue1 }}<br></span>
    @if (selectedMAM.rue2) {
    <span>{{ selectedMAM.rue2 }}<br></span>
    }
    @if (selectedMAM.rue3) {
    <span>{{ selectedMAM.rue3 }}<br></span>
    }
    <span>{{ selectedMAM.codePostal }} {{ selectedMAM.ville }}</span>
  </p>

  @if(selectedMAM.email){
  <p class="fx-direction-row fx-start-center">
    <mat-icon style="margin-right: 5px;">alternate_email</mat-icon>
    <span>{{selectedMAM.email}}</span>
  </p>
  }

  @if(selectedMAM.telephone){
  <p class="fx-direction-row fx-start-center">
    <mat-icon style="margin-right: 5px;">local_phone</mat-icon>
    <span>{{ selectedMAM.telephone }}</span>
  </p>
  }
  }
</ng-template>

<ng-template #valeursLibres>
  <div *ngFor="let valeurLibre of listValeursLibres; let i = index">
    <div [ngSwitch]="valeurLibre.type">
      <p *ngSwitchCase="'datepicker'">
        <b>{{valeurLibre.label}} : </b> {{valeurLibre.value | date:"shortDate"}}
      </p>
      <p *ngSwitchDefault>
        <b>{{valeurLibre.label}} : </b> {{valeurLibre.value}}
      </p>
    </div>

  </div>
</ng-template>

<ng-template #coordinates>
  @if(assmatData.emailPro){
  <p class="fx-direction-row fx-start-center">
    <mat-icon style="margin-right: 5px;">alternate_email</mat-icon>
    <span>{{assmatData.emailPro}}</span>
  </p>
  }

  @if(assmatData.telephonePro){
  <p class="fx-direction-row fx-start-center">
    <mat-icon style="margin-right: 5px;">local_phone</mat-icon>
    <span>{{ assmatData.telephonePro }}</span>
  </p>
  }
</ng-template>


<ng-template #souhaitsAccueil>
  <div *ngIf="complement">
    <p *ngIf="complement.nbEnfantSouhait"><b>Nombre d'enfant souhaité : </b> {{complement.nbEnfantSouhait}}</p>
    <p *ngIf="complement.ageDebutEnfantSouhait && complement.ageFinEnfantSouhait"><b>Tranche d'âge souhaitée : </b>
      Entre {{complement.ageDebutEnfantSouhait}} et
      {{complement.ageFinEnfantSouhait}} mois</p>
  </div>
  <div *ngIf="modeAccueil"><b>Mode(s) d'accueil(s) souhaité(s) : </b>
    <ul>
      <li *ngIf="modeAccueil.accueilTempsComplet === 'Oui'">
        Temps Complet
      </li>
      <li *ngIf="modeAccueil.accueilTempsPartiel === 'Oui'">
        Temps Partiel
      </li>
      <li *ngIf="modeAccueil.accueilPeriscolaire === 'Oui'">
        Accueil periscolaire
      </li>
      <li *ngIf="modeAccueil.accueilAtypique === 'Oui'">
        Accueil avec horaires atypiques
      </li>
      <li *ngIf="modeAccueil.accueilUrgence === 'Oui'">
        Accueil en urgence
      </li>
      <li *ngIf="modeAccueil.accueilHandicap === 'Oui'">
        Accueil d'un enfant en situation de handicap
      </li>
      <li *ngIf="modeAccueil.accueilNuit === 'Oui'">
        Accueil nuit
      </li>
      <li *ngIf="modeAccueil.accueilWeekend === 'Oui'">
        Accueil weekend
      </li>
      <li *ngIf="modeAccueil.accueilDepannage === 'Oui'">
        Accueil dépannage
      </li>
      <li *ngIf="modeAccueil.accueilMercrediVacScolaires === 'Oui'">
        Accueil mercredis / vacances scolaires
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #loader>
  <app-loader message="Chargement des données..." class="margin"></app-loader>
</ng-template>